import 'bootstrap/js/src/tab';
import TWER_UPLOADS from './modules/uploads';
import { initEditor } from './modules/editor';

class TrewelerSettings {
  constructor() {
    this.$textarea = document.getElementById('js-twer-editor-textarea');
    initEditor(this.$textarea);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new TrewelerSettings();
  new TWER_UPLOADS(jQuery);
});
